import React from "react";
import { inject, observer } from "mobx-react";
import { IAppStore } from "../../../../stores/Interfaces";
import { EDIT_DECLARANT } from "../../../../constants/authorize";
import Select from "../../columns/select";
import { CHANGE_TABLE_CELL_EVENT } from "../../../../constants/events";
import { Declarant } from "../../../../models/Declarant";
import { DEPARTMENT_ID } from "../../../../constants/table";
import canEditDeclarantField from "../../../../utils/canEditDeclarantField";

interface Props {
  store?: IAppStore;
  entity: Declarant;
}

const Department: React.FC<Props> = ({ store, entity }) => {
  const value = (entity as Declarant).department?.name || "";

  if (store?.userStore.authorizeByPermission(EDIT_DECLARANT)) {
    return (
      <Select
        string={value}
        entityKey={DEPARTMENT_ID}
        entityId={entity.id}
        options={store?.settingsStore.departments}
        eventKey={CHANGE_TABLE_CELL_EVENT}
        disabled={!canEditDeclarantField(entity, store)}
        showSearch
      />
    );
  }

  return <>{value}</>;
};
export default inject("store")(observer(Department));
